export const SITE = {
  name: 'CampusOne',
  tagline: 'your institution workspace',
  url: 'https://app.campusone.cskytelecoms.com',
  domain: 'app.campusone.cskytelecoms.com',
  locale: 'en_US',
  alternateLocale: 'fr_FR',
  ogImage: '/campusone-og-image.png',
  twitterCard: 'summary_large_image',
  themeColor: '#0057B8',
  backgroundColor: '#00206B',
  author: 'CSKY Telecom',
} as const;

export function absoluteUrl(path: string, locale?: string): string {
  const prefix = locale && locale !== 'en' ? `/${locale}` : '';
  return `${SITE.url}${prefix}${path}`;
}

export function alternateUrls(path: string): Array<{ hreflang: string; href: string }> {
  return [
    { hreflang: 'en', href: absoluteUrl(path) },
    { hreflang: 'fr', href: absoluteUrl(path, 'fr') },
    { hreflang: 'x-default', href: absoluteUrl(path) },
  ];
}

export interface RouteMeta {
  key: string;
  path: string;
  title: string;
  description: string;
  noindex?: boolean;
}

const ROUTES: RouteMeta[] = [
  {
    key: 'home',
    path: '/',
    title: 'CampusOne — your workspace',
    description: 'Your CampusOne workspace — access products, manage your institution, and get work done.',
    noindex: true,
  },
  {
    key: 'products',
    path: '/products',
    title: 'Products — CampusOne',
    description: 'Browse and launch your available CampusOne products and services.',
    noindex: true,
  },
  {
    key: 'notifications',
    path: '/notifications',
    title: 'Notifications — CampusOne',
    description: 'Stay informed with your CampusOne notifications and alerts.',
    noindex: true,
  },
];

export function findRoute(path: string): RouteMeta | undefined {
  return ROUTES.find((r) => r.path === path);
}

export function normalisePath(path: string): string {
  return path.replace(/\/+$/, '') || '/';
}
